import React from "react";

function NestedItem({ keyVariable, values }) {
  if (Array.isArray(keyVariable) && values[keyVariable[0]]) {
    return <span className="pl-h">
      {values[keyVariable[0]][keyVariable[1]]}
    </span>
  } else {
    return <span className="pl-h">
      {values[keyVariable]}
    </span>
  }
}

function InfoLine({ props, label, index }) {
  if (index % 3 === 0) {
    return <div className="col-xs-12 col-sm-6 col-md-4 py-0">
      <div className="mb-1">
        <label className="d-label">
          <strong>{label}</strong>
        </label>
        <NestedItem keyVariable={props.keys[index]} values={props.values} />
      </div>
    </div>
  }
  else {
    return <div className="col-xs-12 col-sm-6 col-md-4 py-0">
      <div className="mb-1">
        <label className="d-label">
          <strong>{label}</strong>
        </label>
        <NestedItem keyVariable={props.keys[index]} values={props.values} />
      </div>
    </div>
  }
}

export const InfoBox = props => <div className="box px-1  pt-1 px-sm-2 pt-sm-2 pb-sm-1 mb-1">
  <div className="row">
    {props.labels.map((key, index) => <InfoLine props={props} label={key} index={index} />
    )}
  </div>
</div>
